import $ from 'jquery';

const sliderProductFeature = () => {
    const el = {
        container: '.mi-carousel__product',
        item: '.swiper-slide',
        navigationButton: '.elementor-swiper-button', 
    }

    if (!$(el.container).length) return;

    const exec = () => {
        const isDescktop = window.innerWidth >= 1024;
        if(!isDescktop) return;

        $(el.container).each(function() {
            const $carousel = $(this);
            const $slideCount = $carousel.find(el.item).length;

            if ($slideCount <= 4) {
                $carousel.find(el.navigationButton).hide();
            }
        })
    }

    exec();

}

try {
    sliderProductFeature();

    $(window).on('resize', () => {
        sliderProductFeature();
    });
    
} catch (e) {
    console.error(e);
}